import React from 'react';
import { Switch, Card } from 'antd';
import { BellOutlined, InfoCircleFilled, SafetyOutlined } from '@ant-design/icons';
import './AlertBadge.css';

export const ManageAlertsHeader = ({ title, subtitle }) => (
  <div className="manage-alerts-header">
    <div className="manage-alerts-header-icon-wrapper">
      <BellOutlined />
    </div>
    <div className="manage-alerts-header-text">
      <h4 className="manage-alerts-header-title">{title}</h4>
      <p className="manage-alerts-header-desc">{subtitle}</p>
    </div>
  </div>
);

export const CustomAlertBanner = ({ title, subtitle, icon }) => (
  <div className="custom-alert-banner">
    <div className="custom-alert-banner-icon">
      {icon || <InfoCircleFilled />}
    </div>
    <div className="custom-alert-banner-content">
      <span className="custom-alert-banner-title">{title}</span>
      <span className="custom-alert-banner-desc">{subtitle}</span>
    </div>
  </div>
);

export const CustomBadge = ({ children, type = 'default', icon, pill = false, style, ...props }) => {
  let typeClass = 'custom-badge-disabled';
  if (type === 'success' || type === 'enabled' || type === 'completed') typeClass = 'custom-badge-enabled';
  if (type === 'warning' || type === 'repeat' || type === 'in_progress') typeClass = 'custom-badge-warning';

  const pillStyle = pill ? {
    borderRadius: 20,
    padding: '3px 10px',
    height: 'auto',
    lineHeight: '1.2',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0
  } : {};

  return (
    <span
      className={`custom-badge ${typeClass}`}
      style={{
        ...pillStyle,
        ...style
      }}
      {...props}
    >
      {icon && <span style={{ display: 'inline-flex', alignItems: 'center' }}>{icon}</span>}
      {children}
    </span>
  );
};

export const CustomCard = ({ children, className, style, bodyStyle, hoverable = false, ...props }) => {
  return (
    <Card
      bordered={false}
      hoverable={hoverable}
      className={className}
      style={{
        borderRadius: 18,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.04)',
        background: '#ffffff',
        overflow: 'hidden',
        ...style
      }}
      bodyStyle={{
        padding: '24px 20px',
        ...bodyStyle
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

export const CustomAlertCard = ({ title, desc, detail, detailIcon, icon: IconComponent, checked, onChange }) => {
  return (
    <CustomCard
      hoverable
      className="custom-alert-card"
      style={{ marginBottom: 16 }}
      bodyStyle={{ padding: '18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
    >
      <div className="custom-alert-card-left">
        <div className="custom-alert-card-icon-wrapper">
          {IconComponent && <IconComponent />}
        </div>
        <div className="custom-alert-card-info">

          <div className="custom-alert-card-title-row">
            <span className="custom-alert-card-title">{title}</span>
            <CustomBadge type={checked ? 'enabled' : 'disabled'}>
              {checked ? 'Enabled' : 'Disabled'}
            </CustomBadge>
          </div>

          <span className="custom-alert-card-desc">{desc}</span>
          {detail && (
            <span className="custom-alert-card-detail">
              {detailIcon}
              {detail}
            </span>
          )}

        </div>
      </div>
      <div className="custom-alert-card-right">
        <Switch checked={checked} onChange={onChange} />
      </div>
    </CustomCard>
  );
};
